"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenseHoverStatus = exports.HoverStatusLabel = void 0;
const React = require("react");
exports.HoverStatusLabel = (props) => {
    const { status, label } = props;
    return (React.createElement("p", null,
        React.createElement("span", { style: { color: status ? "green" : "red" } },
            label,
            ": "),
        status ? "true" : "false"));
};
exports.DispenseHoverStatus = (props) => {
    const { loading, isUnsubmitted, isPending, isApproved, haveSignatures, claimSelected, enoughQty, validLots, hasDispensed, readyForDispense, isIntended, isDone, isRefill, isReversed, ispendingCopayAmt //D-002.810
     } = props;
    // D-002.810 <HoverStatusLabel status={ispendingCopayAmt} label="ispendingCopayAmt" />
    return (React.createElement("div", { className: "dispense-conflict-hover-html" },
        React.createElement(exports.HoverStatusLabel, { status: loading, label: "loading" }),
        React.createElement(exports.HoverStatusLabel, { status: isUnsubmitted, label: "isUnsubmitted" }),
        React.createElement(exports.HoverStatusLabel, { status: isPending, label: "isPending" }),
        React.createElement(exports.HoverStatusLabel, { status: isApproved, label: "isApproved" }),
        React.createElement(exports.HoverStatusLabel, { status: haveSignatures, label: "haveSignatures" }),
        React.createElement(exports.HoverStatusLabel, { status: claimSelected, label: "claimSelected" }),
        React.createElement(exports.HoverStatusLabel, { status: enoughQty, label: "enoughQty" }),
        React.createElement(exports.HoverStatusLabel, { status: validLots, label: "validLots" }),
        React.createElement(exports.HoverStatusLabel, { status: hasDispensed, label: "hasDispensed" }),
        React.createElement(exports.HoverStatusLabel, { status: readyForDispense, label: "readyForDispense" }),
        React.createElement(exports.HoverStatusLabel, { status: isIntended, label: "isIntended" }),
        React.createElement(exports.HoverStatusLabel, { status: isDone, label: "isDone" }),
        React.createElement(exports.HoverStatusLabel, { status: isRefill, label: "isRefill" }),
        React.createElement(exports.HoverStatusLabel, { status: isReversed, label: "isReversed" }),
        React.createElement(exports.HoverStatusLabel, { status: ispendingCopayAmt, label: "ispendingCopayAmt" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/dispense-hover-status/dispense-hover-status.tsx
// module id = 3749
// module chunks = 0